import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ListaService } from '../../../_services/lista.service';
import { SelectItem } from 'primeng/api';
import { AdministradorDocumentoService } from '../../../_services/administrador-documento.service';

@Component({
  moduleId: module.id,
  templateUrl: './administration-documents-detail.component.html',
  selector: 'administration-documents-detail-component'
})
export class AdministrationDocumentsDetailComponent implements OnInit {
  loading: boolean = false;
  admDocument: any;
  listTypeValidity: SelectItem[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private listaService: ListaService,
    private administradorDocumentoService: AdministradorDocumentoService
  ) {
  }

  ngOnInit(): void {
    this.loading = true;
    this.listaService.getMasterDetails('ListasTiposVigencias').subscribe(res => {
      this.listTypeValidity = res.map(item => ({
        label: item.nombre,
        value: item.idLista
      }));  
    });
    if (this.route.snapshot.params['id']) {
      this.administradorDocumentoService.getById(this.route.snapshot.params['id']).subscribe(data => {
        this.admDocument = data;
        this.loading = false;
      });
    } else {
      this.loading = false;
  }
  }

  labelTypeValidity(id: any): string {
    const tipo = this.listTypeValidity.find(t => t.value === id);
    return tipo ? tipo.label : '';
  }

  goBack(): void {
    this.router.navigate( [ '/apl/vigencias' ], { queryParams: { tab: 2 } } );
  }
}
